import type { TicketedEventSchoolBranding } from '@school-journey/shared-types'
import { SchoolLogo } from './school-logo'

/**
 * The public site chrome: crest/logo + school name, nothing else (no search or
 * account chrome — these pages are for signed-out visitors).
 *
 * Extracted from `EventsGridClient` because the collection page renders that
 * grid BELOW its own collection header, which put this bar in the middle of the
 * page — a second school identity appearing after the collection title. Owned
 * by the page now, so each public page renders it exactly once, at the top.
 *
 * Not sticky: it carries identity, not navigation, so following the reader down
 * the page bought nothing and cost vertical space on every scroll.
 */
export function PublicSchoolHeader({ school }: { school: TicketedEventSchoolBranding }) {
  return (
    <header className="border-border bg-background border-b">
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center gap-3 px-6">
        <SchoolLogo school={school} />
        <div className="text-foreground text-[19px] font-extrabold tracking-[-.2px]">{school.name}</div>
      </div>
    </header>
  )
}
